module.exports = __webpack_public_path__ + "static/media/myPages.6925c70e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/myPages.jpg
// module id = 1625
// module chunks = 0